import { Component, OnInit } from '@angular/core';
import { ModelService } from '../../model.service';
import { Team } from "../../classes/team";
import {Router} from '@angular/router';

@Component({
  selector: 'app-leaderboard',
  templateUrl: './leaderboard.component.html',
  styleUrls: ['./leaderboard.component.css']
})
export class LeaderboardComponent implements OnInit {

  title = 'Leaderboard';
  position = 0;
  teams: Team[];
  user = JSON.parse(localStorage.getItem('currentUser'));
  user_name = this.user.name;
  team_name = this.user.team_name;

  constructor(private modelService: ModelService, private router: Router) { }

  ngOnInit() {
    this.getTeams();
  }

  getTeams(): void {
  this.modelService.getTeams().subscribe(teams => {this.teams = teams; console.log(this.teams);},  err => {
        console.log("Error occured.")
        //this.router.navigateByUrl('login');
      });
}



}


/*
getTeams(): void {
this.modelService.getTeams()
  .subscribe(teams => this.teams = teams);
}
*/



// WEBPACK FOOTER //
// /Users/boshaughnessy/Documents/Web/ClonkeenChallenge/clonkeen-challenge/src/app/content/leaderboard/leaderboard.component.ts